import { CM_PRIMARY_ID, NOMINATION_STATUS } from './constants';

export const tableRowsValuesScoring = (
  committeeMembers,
  candidateScoresArray,
  nominationArray,
  candidateArray,
  committeeName,
  committeeId,
  electionTypeId,
  coiDeclarationArray,
  currentRound,
  biasTrainingArray,
  titlesTypes,
) => {
  const tableData = [];

  const relevantNominations = nominationArray.filter((nomination) => {
    const isShortlisted =
      nomination.attributes.nominationStatusTypeId ===
        NOMINATION_STATUS.SUBMITTED ||
      nomination.attributes.nominationStatusTypeId ===
        NOMINATION_STATUS.SHORTLISTED ||
      nomination.attributes.nominationStatusTypeId ===
        NOMINATION_STATUS.RECOMMENDED;

    if (!isShortlisted) return false;

    if (committeeId === CM_PRIMARY_ID) {
      return nomination.attributes.electionTypeId === electionTypeId;
    }

    return (
      nomination.attributes.sectionalCommitteeId === committeeId &&
      nomination.attributes.electionTypeId === electionTypeId
    );
  });

  const candidateIds = [
    ...new Set(relevantNominations.map((nom) => nom.attributes.candidateId)),
  ];
  const totalCandidates = candidateIds.length;

  if (totalCandidates === 0) {
    return tableData;
  }

  committeeMembers.forEach((member) => {
    const memberCandidateIds = candidateIds.filter((candidateId) => {
      if (!coiDeclarationArray.length || !currentRound) return true;

      const hasDirectConflict = coiDeclarationArray.some(
        (coi) =>
          coi.attributes.candidateId === candidateId &&
          coi.attributes.userId === member.id &&
          coi.attributes.nominationRound === currentRound &&
          coi.attributes.coiTypes?.data?.some(
            (coiType) => coiType.attributes.category === 'direct',
          ),
      );

      return !hasDirectConflict;
    });

    const memberTotalCandidates = memberCandidateIds.length;

    const memberScores = candidateScoresArray?.filter((score) => {
      const scoreUserId = score.attributes?.userId || score.userId;

      const scoreElectionTypeId =
        score.attributes?.electionTypeId || score.electionTypeId;
      const scoreCandidateId =
        score.attributes?.candidateId || score.candidateId;

      const matchesUser = scoreUserId === member.id;

      const matchesElectionType = scoreElectionTypeId === electionTypeId;
      const matchesCandidate = memberCandidateIds.includes(scoreCandidateId);

      return matchesUser && matchesElectionType && matchesCandidate;
    });

    const completedScores = memberScores.filter((score) => {
      const isCompleted = score.attributes?.isCompleted || score.isCompleted;
      const totalScore = score.attributes?.totalScore || score.totalScore;

      return isCompleted && totalScore >= 0;
    }).length;

    const completionPercentage =
      memberTotalCandidates > 0
        ? Math.round((completedScores / memberTotalCandidates) * 100)
        : 0;

    const matchingTrainingRecords = biasTrainingArray.filter((training) => {
      const trainingUserId = training.attributes?.userId || training.userId;
      const trainingRound =
        training.attributes?.nominationRound || training.nominationRound;

      const userIdMatch = String(trainingUserId) === String(member.id);
      const roundMatch = String(trainingRound) === String(currentRound);

      return userIdMatch && roundMatch;
    });

    const memberBiasTraining = matchingTrainingRecords[0];

    const biasTrainingStatus =
      memberBiasTraining?.attributes?.isCompleted ||
      memberBiasTraining?.isCompleted
        ? 'Complete'
        : 'Incomplete';

    const memberDisplayName = member?.isChair ? `${member.name}` : member.name;

    tableData.push({
      memberName: memberDisplayName,
      memberRole: member?.isChair ? 'Chair' : 'Member',
      committeeName,
      sectionalCommitteeId: committeeId,
      electionTypeId,
      electionType:
        titlesTypes && electionTypeId ? titlesTypes[electionTypeId] : '',
      biasTrainingStatus,
      scoringProgress: `${completedScores} out of ${memberTotalCandidates}`,
      completionPercentage: `${completionPercentage}%`,
    });
  });

  return tableData;
};
